import { FormattedMessage, useIntl } from 'react-intl';
import { Button } from 'components/ui/atoms/button';
import { Icon } from 'components/ui/atoms/icons';
import { AboutCourseProps } from './types';

export const AboutCourse = ({ url, startDate, duration }: AboutCourseProps) => {
  const { formatMessage } = useIntl();

  const { low, high } = duration;
  const unit = duration?.unit ?? 'weeks';
  const hasCourseDuration = !!(low ?? high);
  const courseDuration =
    low && high ? `${low}-${high} ${unit}` : `${low ?? high!} ${unit}`;

  const startButtonText = formatMessage({
    id: 'payment.thankyou.product.start.course',
    defaultMessage: 'Start course',
    description: 'CTA to start the course after successful payment',
  });

  return (
    <>
      <h3 className="m-2 py-2">
        <FormattedMessage
          id="payment.thankyou.product.about.course"
          defaultMessage="About course"
          description="Product about section"
        />
      </h3>
      {!!startDate && (
        <div className="m-2 d-flex align-items-center py-1">
          <Icon
            type="calendar-today"
            svgProps={{
              'aria-label': 'Calendar icon',
              className: 'mr-2 text-dark-700',
            }}
          />
          <h4 className="mb-0">
            <FormattedMessage
              id="payment.thankyou.product.about.course.start.date"
              defaultMessage="Start Date: {courseStartDate}"
              description="Course start date"
              values={{ courseStartDate: startDate }}
            />
          </h4>
        </div>
      )}
      {hasCourseDuration && (
        <div className="m-2 d-flex align-items-center py-1">
          <Icon
            type="timelapse"
            svgProps={{
              'aria-label': 'Timelapse icon',
              className: 'mr-2 text-dark-700',
            }}
          />
          <h4 className="mb-0">
            <FormattedMessage
              id="payment.thankyou.product.about.course.duration"
              defaultMessage="Duration: {courseDuration}"
              description="Course duration"
              values={{ courseDuration }}
            />
          </h4>
        </div>
      )}
      <div className="row">
        <div className="col-7 col-lg-4 mx-auto text-nowrap">
          <Button
            variant="brand"
            size="lg"
            asChild
            radius="none"
            className="mt-4 tw-w-full"
          >
            <a href={url}>{startButtonText}</a>
          </Button>
        </div>
      </div>
    </>
  );
};
